<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 14L14 2M2 2L14 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGClose',
};
</script>

<style scoped lang="scss">

</style>
